/**
 * Tempo máximo de espera por um evento do SDK 3DS depois do `Checkout`.
 *
 * 120 s é deliberado: um desafio com redirecionamento ao emissor mais o
 * usuário buscando o SMS leva de 30 a 90 s. Um timeout de 60 s cortaria
 * autenticação legítima — não reduza sem medir.
 */
export const TIMEOUT_3DS_MS = 120_000

export interface Watchdog3DS {
  /** Arma o timer; um timer anterior ainda pendente é descartado. */
  armar: (onTimeout: () => void) => void
  /** Cancela o timer pendente, se houver. */
  limpar: () => void
}

/**
 * O SDK 3DS não garante que algum evento sempre dispare depois do `Checkout`
 * (desafio que não abre, queda de rede, janela do emissor fechada). Sem este
 * watchdog a tela fica travada até a compra expirar.
 */
export default function criarWatchdog3DS(timeoutMs: number = TIMEOUT_3DS_MS): Watchdog3DS {
  let timer: ReturnType<typeof setTimeout> | null = null

  function limpar() {
    if (timer !== null) {
      clearTimeout(timer)
      timer = null
    }
  }

  function armar(onTimeout: () => void) {
    limpar()
    timer = setTimeout(() => {
      timer = null
      onTimeout()
    }, timeoutMs)
  }

  return { armar, limpar }
}
